import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ListLayoutMultipleComponent } from 'gung-list';
import { ListLayout } from 'gung-list/lib/types';
import { MetadataService, Order, OrderService, SelectedCustomerService } from 'gung-standard';
import { JeevesOpenOrdersListTableConfigService } from 'gung-standard-jeeves';
import { forkJoin, of } from 'rxjs';
import { first, map, mergeMap } from 'rxjs';
import { RefCustomerService } from '../ref-customer/ref-customer.service';
import { RefOpenOrderTableComponent } from '../../components/ref-open-order-table/ref-open-order-table.component';
import { DateUtilService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class RefJeevesOpenOrdersListTableConfigService extends JeevesOpenOrdersListTableConfigService {
  constructor(
    protected translationService: TranslateService,
    protected orderService: OrderService,
    protected selectedCustomerService: SelectedCustomerService,
    protected metadataService: MetadataService,
    protected customerService: RefCustomerService,
    protected dateUtilService: DateUtilService
  ) {
    super(translationService, orderService, selectedCustomerService, metadataService, customerService, dateUtilService);
  }

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => RefOpenOrderTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Product grid'
      }
    ];
  }

  getItems() {
    return this.orderService.getOpenOrders().pipe(
      map(orders => orders.filter(o => o.billingCustomerId !== 'Distr')),
      mergeMap(items => forkJoin([of(items), this.customerService.getCustomers().pipe(first())])),
      map(([orders, customers]) => {
        const result = orders.map(order => {
          return {
            ...order,
            extra: {
              ...order.extra
            }
          };
        });

        result.map(resOrder => {
          const cust = customers.find(customer => customer.id === resOrder.deliveryCustomerId);
          resOrder.extra.customerName = cust ? cust.name : '';
          return resOrder;
        });

        const filteredResult = result.filter(c => {
          return c.extra.oh.ordstat <= 20;
        });

        const sorted = filteredResult.sort((a, b) => {
          if (a.extra.oh.orddatum > b.extra.oh.orddatum) {
            return 1;
          }
          if (a.extra.oh.orddatum < b.extra.oh.orddatum) {
            return -1;
          }
          return 0;
        });

        return sorted.reverse();
      }),
      map(orders => {
        for (const order of orders) {
          const ohfakttb: number = Number(order.extra.oh.ohfakttb) || 0;
          const ohordkostnad: number = Number(order.extra.oh.ohordkostnad) || 0;
          const ohordsum: number = Number(order.extra.oh.ohordsum) || 0;

          const divide = ohordkostnad / ohordsum;
          // Check if it's a division by 0, if it is and there is no margin, set marginPercentage as 0% else make percentage negative
          // If division is not by 0 then use normal value to calculate normal percentage
          const marginPercentage = ((!isFinite(divide) ? (ohfakttb !== 0 ? 2 : 1) : divide) - 1) * (-100);

          order.extra._gungMargin = ohfakttb;
          order.extra._gungMarginPercentage = marginPercentage;
        }

        return orders;
      })
    );
  }
}
